import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import { buildSkuSelectionFields } from 'ai/analytics/utils/sotFields';
import { EVENT_NAMES } from 'ai/analytics/events';
import { getOrderedValidVariations } from 'ai/utils/skuSelectorUtils';
import { getSuperChatReferrer } from 'ai/utils/sessionStorage';

let hasFiredSwatchClick = false;


export function trackSkuSwatchClick() {
    if (hasFiredSwatchClick) {
        return;
    }

    hasFiredSwatchClick = true;

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo: anaConsts.SUPER_CHAT.SUPERCHAT_SKU_SWATCH
        }
    });
}

export function resetSkuSwatchClickCache() {
    hasFiredSwatchClick = false;
}

export function getSkuSelectorVariantType(product) {
    return getOrderedValidVariations(product?.variations)[0]?.variation_type || null;
}

export function trackVariantSelection({
    product, skuId, previousSkuId, sessionId
}) {
    if (!product || !skuId || skuId === previousSkuId) {
        return;
    }

    trackSkuSwatchClick();

    const eventName = EVENT_NAMES.SKU_SELECTION;

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...buildSkuSelectionFields({
                sessionId,
                productId: product.id,
                skuId,
                colorIqSkuId: product.pre_selected_sku_id,
                referrer: getSuperChatReferrer()
            })
        }
    });
}
